export function generateCategoryEdges(index, source, target) {
  return {
    id: `${index}-${source}=${target}-category-edge`,
    source,
    target,
    type: "straight",
    style: {
      strokeWidth: 4,
      stroke: "black",
    },
  };
}

export function generatePropertyEdges(propertyID, source, target) {
  return {
    id: `${propertyID}-${source}=${target}-property-edge`,
    source,
    target,
    type: "straight",
    style: {
      strokeWidth: 2,
      stroke: "black",
    },
  };
}
